import globe from "@/assets/maestro-hands.png";

// Project Management Orchestrator brand lockup: stardust globe + wordmark + "PLAN · MANAGE · ORCHESTRATE" subtitle.
export default function AnimatedLogo({ className = "", backdrop = false, onDark = false }) {
  const dark = backdrop || onDark;
  return (
    <div className={`orbit-logo relative inline-flex items-center justify-center ${backdrop ? "orbit-logo--backdrop" : ""} ${className}`} data-testid="animated-logo">
      <div className="orbit-logo-glow" aria-hidden="true" />
      <div className="relative z-10 w-full flex flex-col items-center">
        <img src={globe} alt="Project Management Orchestrator" className="orbit-logo-img w-full h-auto select-none" draggable="false" />
        <p className="orbit-logo-wordmark font-display font-extrabold tracking-tight leading-none mt-1" data-testid="logo-wordmark">
          <span className={`${dark ? "text-slate-200" : "text-slate-700"} drop-shadow-[0_2px_6px_rgba(126,166,255,0.45)]`}>Project Management </span>
          <span className="bg-gradient-to-r from-[#7ea6ff] to-[#2f6bff] bg-clip-text text-transparent drop-shadow-[0_2px_6px_rgba(47,107,255,0.4)]">Orchestrator</span>
        </p>
        <p className="orbit-logo-subtitle font-display font-bold text-[#7ea6ff] mt-2" data-testid="logo-subtitle">PLAN · MANAGE · ORCHESTRATE</p>
      </div>
    </div>
  );
}
